import { FormControl, FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { BaseLayerComponent } from "../base-layer/base-layer.component";
import { Component, Input } from "@angular/core";

@Component({
  template: "",
  standalone: false,
})
export abstract class WmtsLayerComponent extends BaseLayerComponent {
  layers: any[] = [];

  tilesMatrixSet: any[] = [];

  matrixConfiguration: any;

  hide = true;

  isLoading = true;

  urlType: string;

  isAuthRequired: boolean;

  @Input()
  url = "";

  changed: boolean = true;

  username: string = "";

  password: string = "";

  form = new FormGroup({
    username: new FormControl(""),
    password: new FormControl(""),
  });

  protected constructor(
    protected http: HttpClient,
    protected viewerConfigurationService: ViewerConfigurationService,
    protected matDialog: MatDialog,
    protected viewerService: BaseViewerService,
  ) {
    super(http, viewerConfigurationService, matDialog);
  }

  onAuthRequireChange(event: any) {
    this.isAuthRequired = event.value;
    this.changed = true;
    document.getElementById("lblError").innerHTML = "";
  }

  changeInput() {
    this.changed = true;
  }

  fieldsCompleted() {
    if (this.isAuthRequired) {
      return this.form.get("username").value !== "" && this.form.get("password").value !== "" && this.changed;
    }

    return this.changed;
  }

  usernameExists() {
    return this.form.get("username").value.length > 0;
  }

  passwordExists() {
    return this.form.get("password").value.length > 0;
  }

  getLayerInformation() {
    document.getElementById("lblError").innerHTML = "";
    this.changed = false;
    this.isLoading = true;
    this.username = this.form.get("username").value;
    this.password = this.form.get("password").value;
    let { url } = this;

    url +=
      url.indexOf("?") > -1
        ? "&service=wmts&version=1.0.0&request=GetCapabilities"
        : "?service=wmts&version=1.0.0&request=GetCapabilities";

    let credentials;
    if (this.isAuthRequired && this.username && this.username.length && this.password && this.password.length) {
      credentials = `${this.username}:${this.password}`;
    }
    this.getCapabilities(url, credentials);
  }

  getCapabilitiesSuccess(data: Object) {
    this.isLoading = true;
    let capability;
    const formatter = this.viewerService.getCoreMap().getWMTSFormatter();
    try {
      const response = formatter.read(data);
      this.matrixConfiguration = response;
      // this object contains all the GetCapabilities data
      capability = response.Contents;
    } catch (e) {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "Bad data was returned";
      return;
    }
    if (!capability || !capability.Layer) {
      this.isLoading = false;
      this.cdr.detectChanges();
      document.getElementById("lblError").innerHTML = "No layers were returned";
      return;
    }
    this.layers = capability.Layer;
    this.tilesMatrixSet = capability.TileMatrixSet;
    this.changed = true;
    this.isLoading = false;
    this.cdr.detectChanges();
    this.loadLayers();
  }

  getCapabilitiesError() {
    this.isLoading = false;
    this.cdr.detectChanges();
    document.getElementById("lblError").innerHTML = "Failed to load url";
  }

  abstract loadLayers();
}
